<div class="flex h-full flex-col">
  <mat-sidenav-container class="shell-container h-full" [hasBackdrop]="false">
    <!-- Left Sidenav (Main Navigation) -->
    <mat-sidenav mode="side" [opened]="state.showSidenav" [disableClose]="true" class="border-r border-neutral-200">
      <div class="flex h-full flex-col">
        <!-- Logo Section -->
        <div class="flex w-full items-center justify-center px-6 pt-5">
          <img src="/assets/images/dojostack-logo.svg" alt="DojoStack" class="h-8" />
        </div>

        <div class="flex w-full flex-col items-start p-4">
          <!-- General Section -->
          <div class="mb-6 w-full">
            <h3 class="mb-1 px-2 text-xs font-semibold tracking-wide text-gray-400 dark:text-gray-500">General</h3>
            <div class="flex w-full flex-col gap-0.5">
              <a
                [routerLink]="['/overview']"
                routerLinkActive="active"
                class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
                #overviewRla="routerLinkActive"
              >
                <dojo-icon
                  [icon]="'gauge-high'"
                  [iconClass]="overviewRla.isActive ? 'text-sky-500' : 'text-secondary'"
                  [size]="12"
                  class="mr-2"
                />
                <span class="truncate">Overview</span>
              </a>
              <a
                [routerLink]="['/', CmsUrlParts.Admin]"
                routerLinkActive="active"
                class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
                #adminRla="routerLinkActive"
                *dojoIfUserHasRole="'ADMIN'"
              >
                <dojo-icon
                  [icon]="'user-lock'"
                  [iconClass]="adminRla.isActive ? 'text-sky-500' : 'text-secondary'"
                  [size]="12"
                  class="mr-1.5"
                />
                <span class="truncate">Admin</span>
              </a>
              <a
                [routerLink]="['/', CmsUrlParts.Profile]"
                routerLinkActive="active"
                class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
                #profileRla="routerLinkActive"
              >
                <dojo-icon
                  [icon]="'user-circle'"
                  [iconClass]="profileRla.isActive ? 'text-sky-500' : 'text-secondary'"
                  [size]="12"
                  class="mr-2"
                />
                <span class="truncate">Profile</span>
              </a>
            </div>
          </div>

          <!-- Analytics Section -->
          <div class="mb-6 w-full" *dojoIfUserHasRole="'ADMIN'">
            <h3 class="mb-1 px-2 text-xs font-semibold tracking-wide text-gray-400 dark:text-gray-500">Analytics</h3>
            <div class="flex w-full flex-col gap-0.5">
              <a
                [routerLink]="['/', CmsUrlParts.ContentAnalytics]"
                routerLinkActive="active"
                class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
                #contentAnalyticsRla="routerLinkActive"
              >
                <dojo-icon
                  [icon]="'chart-line'"
                  [iconClass]="contentAnalyticsRla.isActive ? 'text-sky-500' : 'text-secondary'"
                  [size]="12"
                  class="mr-2"
                />
                <span class="truncate">Content</span>
              </a>

              <a
                [routerLink]="['/', CmsUrlParts.UserAnalytics]"
                routerLinkActive="active"
                class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
                #userAnalyticsRla="routerLinkActive"
              >
                <dojo-icon
                  [icon]="'graduation-cap'"
                  [iconClass]="userAnalyticsRla.isActive ? 'text-sky-500' : 'text-secondary'"
                  [size]="12"
                  class="mr-2"
                />
                <span class="truncate">GTM</span>
              </a>
            </div>
          </div>

          <!-- Payment Section -->
          <div class="mb-6 w-full">
            <h3 class="mb-1 px-2 text-xs font-semibold tracking-wide text-gray-400 dark:text-gray-500">Payment</h3>
            <a
              [routerLink]="['/', CmsUrlParts.PaymentRequests]"
              routerLinkActive="active"
              class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
              #paymentRla="routerLinkActive"
            >
              <dojo-icon
                [icon]="'credit-card'"
                [iconClass]="paymentRla.isActive ? 'text-sky-500' : 'text-secondary'"
                [size]="12"
                class="mr-1.5"
              />
              <span class="truncate">Requests</span>
            </a>
          </div>

          <!-- Utility Section -->
          <div class="mb-6 w-full">
            <h3 class="mb-1 px-2 text-xs font-semibold tracking-wide text-gray-400 dark:text-gray-500">Utility</h3>
            <div class="flex w-full flex-col gap-0.5">
              <a
                [routerLink]="['/', CmsUrlParts.PreviewFromJson]"
                routerLinkActive="active"
                class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
                #jsonViewerRla="routerLinkActive"
              >
                <dojo-icon
                  [icon]="'file-code'"
                  [iconClass]="jsonViewerRla.isActive ? 'text-sky-500' : 'text-secondary'"
                  [size]="12"
                  class="mr-2"
                />
                <span class="truncate">JSON Viewer</span>
              </a>
              <a
                [routerLink]="['/', CmsUrlParts.Playground]"
                routerLinkActive="active"
                class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
                #playgroundRla="routerLinkActive"
              >
                <dojo-icon
                  [icon]="'flask'"
                  [iconClass]="playgroundRla.isActive ? 'text-sky-500' : 'text-secondary'"
                  [size]="12"
                  class="mr-2"
                />
                <span class="truncate">Playground</span>
              </a>
            </div>
          </div>

          <!-- Ontology Section -->
          <div class="mb-6 w-full">
            <h3 class="mb-1 px-2 text-xs font-semibold tracking-wide text-gray-400 dark:text-gray-500">Ontology</h3>
            <a
              [routerLink]="['/', CmsUrlParts.Ontology]"
              routerLinkActive="active"
              class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
              #ontologyRla="routerLinkActive"
            >
              <dojo-icon
                [icon]="'diagram-project'"
                [iconClass]="ontologyRla.isActive ? 'text-sky-500' : 'text-secondary'"
                [size]="12"
                class="mr-2"
              />
              <span class="truncate">Ontology</span>
            </a>
          </div>
        </div>

        <div class="mt-auto flex w-full flex-col gap-1 p-4">
          @if (state.isLoading) {
            <div class="text-secondary flex w-full items-center gap-2 px-2 py-1.5">
              <div class="h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent"></div>
              <span class="text-sm">Loading...</span>
            </div>
          } @else {
            <a
              [matMenuTriggerFor]="userMenu"
              class="text-secondary flex w-full max-w-full items-center gap-2 rounded-[0.75rem] px-2 py-1.5 font-semibold transition-colors hover:bg-neutral-50 group-[.is-compact]:px-2"
            >
              <dojo-profile-avatar [size]="20" class="shrink-0" />
              <span class="truncate text-sm">{{ state.user?.fullName }}</span>
            </a>
          }
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="!overflow-hidden bg-white">
      <div class="h-full overflow-y-auto">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<mat-menu #userMenu="matMenu" class="custom-mat-menu">
  <button mat-menu-item (click)="signOut()">
    <dojo-icon class="menu-icon" [icon]="'arrow-right-from-bracket'" />
    <span class="menu-item-label">{{ 'examdojo.registration.sign_out' | transloco }}</span>
  </button>
</mat-menu>
